// @flow
import DiscoveredFeedActionTypes from 'app/common/redux/actions/discoveredFeed/actionTypes';
import ResourceFactory from 'app/common/lib/ResourceFactory';
import type { Thunk } from 'app/common/redux/types';

function getResource(id) {
  return ResourceFactory.create('UserMetadataResource');
}

export type DiscoveredFeedPublic = {
  type: typeof DiscoveredFeedActionTypes.DISCOVERED_FEED_PUBLIC,
  payload: {
    value: boolean,
  },
};

function setDiscoveredFeedPublic(value: boolean): DiscoveredFeedPublic {
  return {
    type: DiscoveredFeedActionTypes.DISCOVERED_FEED_PUBLIC,
    payload: {
      value,
    },
  };
}

export default function discoveredFeedPublic(value: boolean): Thunk<void> {
  return (dispatch) => {
    getResource().callUpdate({ profile_discovered_public: value });
    dispatch(setDiscoveredFeedPublic(value));
  };
}
